import { Text } from "react-native";

export default function WhiteText({children, ...rest}) {
    return <Text style={{...rest.style, color:'white'}}>{children}</Text>
}